import AGENCY_API from '@/api/agencyContract/index';
import { spliceMoreZero } from './util';

export function calAmount(originalAmount, contractCurrencyExchangeRate) {
  // 汇率获取失败时将所有本币计算值清空
  if (!contractCurrencyExchangeRate) {
    return Promise.resolve('');
  }
  // 人民币或者汇率为1
  if (contractCurrencyExchangeRate == 1) {
    return Promise.resolve(spliceMoreZero(originalAmount));
  }
  const params = {
    originalAmount: originalAmount,
    contractCurrencyExchangeRate,
  };
  return new Promise((resolve) => {
    window.vm.$axios.post(AGENCY_API.CAL_LOCAL_AMOUNT, params).then((res) => {
      if (res.data.code === 0) {
        resolve(spliceMoreZero(res.data.data.localAmount));
      } else {
        resolve('');
      }
    });
  });
}
